import i18next from "i18next";

export const useIsGeorgianLocale = () => {
  return i18next.language === "ka"
}
